//--------------------------------------------
//
// Main
//
//--------------------------------------------

import MobileDetect from 'mobile-detect';
require('waypoints/lib/noframework.waypoints.js');

import Scene from './modules/Scene';
import TopScene from './modules/TopScene';
import DomScene from './modules/DomScene';
import AudioManager from './modules/AudioManager';


//--------------------------------------------
// Constants
//
import CONSTANTS from './modules/constants';



//--------------------------------------------
// Main Control
//
		
class Piece {

	constructor(){

		//this is the stack order - z0 skybox scen, z1 dom, z2 arm
		this.scene = null;
		this.domScene = null;
		this.arm = null;
		this.firstClick = false;
		this.domArrows = document.getElementById('dom-arrows');
		this.changeLocation = document.getElementById('changeLocation');

		//Title. will disappear on first click
		this.title = document.getElementById('title');
		this.container = document.getElementById('header');
		this.backup = document.getElementById('backup');
		this.loader = document.getElementById('loader');

		this.startOfFeature = document.getElementById('body-start');

		this.animating = true;

		this.init();
	}


	init(){
		const self = this;


		//--------------------------------------------
		// See if WebGL exists on computer
		//
				
		function detectWebGLContextAndDevice(){

			const md = new MobileDetect(window.navigator.userAgent);

			if (!md.mobile()){
				const canvas = document.createElement('canvas');
				const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

				if (gl && gl instanceof WebGLRenderingContext){
					self.scene = new Scene();
					self.top = new TopScene();
					self.domScene = new DomScene(self.scene);
					self.container.addEventListener('click', clickHandler, false);

				}

				else{
					self.backup.classList.add('visible');
					self.loader.classList.add('gone');
					self.loader.remove();
				}
			}

			else{
				console.log('device');
				self.backup.classList.add('visible');
				self.loader.classList.add('gone');
				self.loader.remove();
			}
		}

		

		//--------------------------------------------
		// Listen for first click on page to start up stuff
		//
				
		function clickHandler(){
			
			if (!this.firstClick){
				self.domScene.startTimeline();
				self.audioManager = AudioManager.init();
				self.scene.addSparks();
				self.title.classList.add('gone');
				self.domArrows.classList.add('visible');
				self.changeLocation.classList.add('visible');
			}

			else{
				return null;
			}
			
			self.container.removeEventListener('click', clickHandler);
		}



		// ------------------------------------------------
		// Kick it off
		//
		detectWebGLContextAndDevice();

		//--------------------------------------------
		// Disable animation after user scrolls past beginning
		//

		const waypoint = new Waypoint({
			element: self.startOfFeature,
			handler: (direction) => {
				if (direction === 'down'){
					self.stopAnimation();
				}

				else{
					self.resumeAnimation();
				}
			}

		})
				

	}



	stopAnimation(){
		this.scene.stop();
		this.top.stop();
	}


	resumeAnimation(){
		this.scene.resume();
		this.top.resume();
	}

}

//--------------------------------------------
// Start when loaded
//		
document.addEventListener('DOMContentLoaded', () => {
	const p = new Piece()
});





